import Container from './trip-request-assign-to-bar-container';

export default Container;
